import React from 'react'

const MedicalCondition = ({ conditions }) => {
  return (
    <div className='bg-gray-20 p-2 max-w-md flex flex-col'>
        <p className="text-teal-300 text-left text-body-sm font-normal capitalize">
        {conditions.map((cond) => cond.conditionName).join(', ')}
        </p>
    </div>
  )
}

export default MedicalCondition